'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var index_es = require('../../../../node_modules/pure-react-carousel/dist/index.es.js');
var SwiperContext = require('./SwiperContext.js');
var index = require('../../../../node_modules/classnames/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Provider = function (props) {
    var children = props.children, totalSlides = props.totalSlides, step = props.step, visibles = props.visibles, isPlaying = props.isPlaying, interval = props.interval, infinite = props.infinite, trayTag = props.trayTag, currentSlide = props.currentSlide, dotGroup = props.dotGroup, dotGroupClassName = props.dotGroupClassName, backIcon = props.backIcon, forwardIcon = props.forwardIcon, showNavigation = props.showNavigation, backText = props.backText, forwardText = props.forwardText, swiperClassName = props.swiperClassName, onSlideChange = props.onSlideChange, others = tslib_es6.__rest(props, ["children", "totalSlides", "step", "visibles", "isPlaying", "interval", "infinite", "trayTag", "currentSlide", "dotGroup", "dotGroupClassName", "backIcon", "forwardIcon", "showNavigation", "backText", "forwardText", "swiperClassName", "onSlideChange"]);
    var _a = React.useState(currentSlide ? currentSlide - 1 : 1), slide = _a[0], setSlide = _a[1];
    return (React__default['default'].createElement(index_es.CarouselProvider, tslib_es6.__assign({}, others, { className: "swiper-slider lp__carousel " + swiperClassName, totalSlides: totalSlides, visibleSlides: visibles, interval: interval || 5000, isPlaying: isPlaying || false, infinite: infinite || true, isIntrinsicHeight: true, currentSlide: slide, naturalSlideHeight: 200, naturalSlideWidth: 150, step: step || 1 }),
        React__default['default'].createElement(SwiperContext.SwiperContext, { onSlideChange: onSlideChange },
            showNavigation && React__default['default'].createElement(index_es.ButtonBack, { className: showNavigation && !backIcon ? "button__back" : 'button_custom' },
                React__default['default'].createElement("div", null, backIcon || backText || 'back')),
            React__default['default'].createElement("div", { className: "swiper-content" },
                React__default['default'].createElement(index_es.Slider, { trayTag: trayTag || "ul" }, children),
                dotGroup && totalSlides > 0 && (React__default['default'].createElement(index_es.DotGroup, tslib_es6.__assign({}, (dotGroupClassName ? { className: dotGroupClassName } : {}), { renderDots: function (value) {
                        var carouselStore = value.carouselStore;
                        var currentSlide = carouselStore.getStoreState().currentSlide;
                        return tslib_es6.__spreadArrays(new Array(totalSlides)).map(function (_, i) { return (React__default['default'].createElement("div", { key: i, className: index['default']('carousel__dot carousel__single-dot', currentSlide === i && 'selected'), onClick: function () {
                                carouselStore.setStoreState({ currentSlide: i });
                                setSlide(i);
                            } })); });
                    } })))),
            showNavigation && React__default['default'].createElement(index_es.ButtonNext, { className: showNavigation && !forwardIcon ? "button__next" : 'button_custom' },
                React__default['default'].createElement("div", null, forwardIcon || forwardText || 'forward')))));
};

exports.Provider = Provider;
//# sourceMappingURL=Provider.js.map
